<script>
import salesApi from "@/api/web/bi/sales.js";
import common from "@/common/mixins/common.js";
import NumberInput from "@/components/NumberInput.vue";
import Vue from "vue";
import { AddToCartByGoods } from "@/api/carts/carts.js";
import { UpdateGoodsNum } from "@/api/carts/carts";

export default {
  components: { NumberInput },
  props: {
    // 商品类型
    goodsTypes: {
      type: Array,
      default: () => [],
    },
    // 语言
    lang: {
      type: String,
      default: "",
    },
    pickerOptions: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      tableData: [],
      query: {
        page: 1,
        size: 10,
        sku: "",
        total: 0,
        time2: "",
        goodsTypeValue: "",// 商品类型[用于提交]
      },
      // lang:"",
      goodsTypeValue: "",  // 查询商品类型
      time2: [],      // 时间选择器

    };
  },
  watch: {
    goodsTypeValue(newValue, oldValue) {
      this.query.goodsTypeValue = newValue[newValue.length - 1];
    },
    time2(newValue, oldValue) {
      this.query.time2 = [];
      this.query.time2 = newValue[0] + "-" + newValue[1];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      salesApi.GetSalesRank({
        page: this.query.page,
        size: this.query.size,
        time2: this.query.time2,
        goods_type_value: this.query.goodsTypeValue,
      }).then(res => {
        const { total, list } = res.data.data;
        console.log(total);
        
        this.tableData = this.filterData(list);
        this.query.total = total;
      });
    },
    // filterData(datas){
    //   let resData = [];
    //   datas.filter(item => {
    //     let imageurl = `https://hwimg.xmvogue.com/thumb/${item.sku}.jpg?x-oss-process=style/440`
    //     resData.push({
    //         sku:item.sku,
    //         images:imageurl,
    //         cnname:item.cnName,
    //         enname:item.enName,
    //         sxprice:item.price,//销售价格
    //         xmnum:item.totalSaleNum, //销售数量
    //         hsnum:item.historyBhNum, // 历史补货数量
    //         tnum:"推荐指数", // 推荐指数
    //         nordernum:item.fdOrderNum, // 拟下单数量
    //         cartnum:0 // 购物车数量
    //       })
    //   })
    //   return resData
    // },
    filterData(datas){
      // 1. 先计算所有商品的分数，并找出最大分数用于归一化
      let scores = [];
      let processedItems = datas.map(item => {
        // 确保数值有效，防止 NaN
        const xmnum = parseFloat(item.totalSaleNum) || 0;
        const hsnum = parseFloat(item.historyBhNum) || 0;
        // 简单算法：销售数量 + 历史补货数量
        const score = xmnum + hsnum;
        scores.push(score);
        let imageurl = `https://hwimg.xmvogue.com/thumb/${item.sku}.jpg?x-oss-process=style/440`;
        let xtnum = '';
        for (let i=1; i<=5; i++){
          if (i <= item.recommend+1) {
            xtnum += `★`;
          } else {
            xtnum += `☆`;
          }
        }

        return {
          sku: item.sku,
          images: imageurl,
          cnname: item.cnName,
          enname: item.enName,
          sxprice: item.price, // 销售价格
          sxprice: item.price, // 销售价格
          xmnum: xmnum, // 销售数量 (确保是数字)
          hsnum: hsnum, // 历史补货数量 (确保是数字)
          score: score, // 临时存储分数
          tnum: xtnum, // 推荐指数 (待计算)
          nordernum: item.fdOrderNum, // 拟下单数量
          cartnum: 0, // 购物车数量 (如果后续需要可以从 item 获取)
          stock:item.stock // 库存数量
        };
      });

      const resData = processedItems.map(item => {
        return item;
      });

      return resData;
    },
    // 点击页码
    handleCurrentChange(val) {
      this.query.page = val;
      this.getData();
    },
    findQuery() {
      this.getData();
    },
    // 购物车数量处理
    editCartNum(sku, num, type){
      UpdateGoodsNum(sku, num, type,"").then(() => {
        this.$message.success(this.$t("Operation complete"));
        this.getData();
      }).catch((err) => {
        this.$message.success(this.$t("Out of stock"));
      });
    }
  },
};
</script>

<template>
  <div class="cxCenter">
    <div class="selType">
      分类:

      <el-cascader v-model="goodsTypeValue" :options="goodsTypes" :placeholder="$t('Please Select Product Category')"
                   :props="{ checkStrictly: true }" clearable size="medium" style="width: 260px">
      </el-cascader>
      &nbsp;&nbsp;&nbsp;
      销售时间:
      <el-date-picker
        v-model="time2"
        :picker-options="pickerOptions"
        align="right"
        end-placeholder="结束日期"
        range-separator="至"
        start-placeholder="开始日期"
        type="datetimerange"
        value-format="timestamp">
      </el-date-picker>
      &nbsp;
      <el-button icon="el-icon-search" size="mini" type="primary" @click="findQuery">搜索</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%;">
      <el-table-column align="center" label="编码" prop="sku" width="150">
      </el-table-column>
      <el-table-column
        align="center"
        label="图片" width="80">
        <template slot-scope="{row}">
          <viewer>
            <img :src="row.images" height="30"
                 style="cursor: pointer;" width="30">
          </viewer>
        </template>
      </el-table-column>
      <el-table-column label="名称" width="260">
        <template slot-scope="{row}">
          <div v-if="lang==='zh-CN'">{{ row.cnname }}</div>
          <div v-else>{{ row.enname }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="门店库存">
        <template slot-scope="{row}">
          <div>{{ row.stock }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="销售金额">
        <template slot-scope="{row}">
          <div>{{ row.sxprice }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="销售数量">
        <template slot-scope="{row}">
          <div>{{ row.xmnum }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="历史补货数量">
        <template slot-scope="{row}">
          <div>{{ row.hsnum }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="推荐指数">
        <template slot-scope="{row}">
          <div>{{ row.tnum }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="拟下单数量">
        <template slot-scope="{row}">
          <div>{{ row.nordernum }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="购物车数量">
        <template slot-scope="{row}">
          <span>{{ row.cartnum }}</span>
          <!-- <a href="#" class="editCartNum" @click="editCartNum(row.item_no, row.purchase_spec, 'decr')">-</a>
          <span>{{ cartShow[row.item_no]['num'] }}</span>
          <a href="#" class="editCartNum" @click="editCartNum(row.item_no, row.purchase_spec, 'incr')" >+</a> -->
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination
        :current-page.sync="query.page"
        :page-size="query.size"
        :total="query.total"
        layout="total, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.selType {
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px 5px;
}
.editCartNum{
  font-size: 20px;
  font-weight: 800;
  margin: 0 10px;
  color: #01a3a3;
}
</style>